export default __webpack_public_path__ + "static/mosaic-cursor-dont-light-fb47d8f63906ac100fdd9632e556a95090703222db8361321c3e5fff247d534c.png";